import { create } from "zustand";

/**
 * Предпросмотр перед включением камеры — как в Discord: прежде чем картинка
 * уйдёт в канал, человек видит себя сам. Выбор живёт на этом устройстве.
 */
const KEY = "airel.camera-preview";

function read(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export const useCameraPreviewOn = create<{ on: boolean }>()(() => ({ on: read() }));

export function setCameraPreviewOn(on: boolean) {
  useCameraPreviewOn.setState({ on });
  try {
    if (on) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch {
    // Не записалось — выбор доживёт до конца сеанса в памяти.
  }
}
